'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (numberText, pattern) {
  // for all strings with length less than 3, just return it
  if (numberText && numberText.length < 2 || !pattern) {
    return '+' + numberText.replace(/\D/g, '');
  }

  var formattedObject = pattern.split('').reduce(function (acc, character) {
    if (acc.remainingText.length === 0) {
      return acc;
    }

    if (character !== '.') {
      return {
        formattedText: acc.formattedText + character,
        remainingText: acc.remainingText
      };
    }

    return {
      formattedText: acc.formattedText + acc.remainingText[0],
      remainingText: acc.remainingText.slice(1)
    };
  }, { formattedText: '', remainingText: numberText });

  return formattedObject.formattedText + formattedObject.remainingText;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.270/js/utils/formatPhoneNumber.js
// module id = 296
// module chunks = 0